
// 关闭弹窗
export function dialogClose(done) {
  let that = this
  that.$confirm('确认关闭？')
    .then(_ => {
        done();
    })
    .catch(_ => {});
}

// 导出
export default dialogClose